/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enterprise_Command_CenterInputs */

const en_enterprise_command_center = /** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise Command Center`)
};

const es_enterprise_command_center = /** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Comando Empresarial`)
};

const fr_enterprise_command_center = /** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de commandement Enterprise`)
};

const de_enterprise_command_center = /** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise Command Center`)
};

const id_enterprise_command_center = /** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Komando Perusahaan`)
};

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const ja_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const zh_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const ar_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const it_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const ru_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const pt_enterprise_command_center = en_enterprise_command_center;

/** @type {(inputs: Enterprise_Command_CenterInputs) => LocalizedString} */
const ko_enterprise_command_center = en_enterprise_command_center;

/**
* | output |
* | --- |
* | "Enterprise Command Center" |
*
* @param {Enterprise_Command_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enterprise_command_center = /** @type {((inputs?: Enterprise_Command_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enterprise_Command_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enterprise_command_center(inputs)
	if (locale === "es") return es_enterprise_command_center(inputs)
	if (locale === "fr") return fr_enterprise_command_center(inputs)
	if (locale === "de") return de_enterprise_command_center(inputs)
	if (locale === "ja") return ja_enterprise_command_center(inputs)
	if (locale === "zh") return zh_enterprise_command_center(inputs)
	if (locale === "ar") return ar_enterprise_command_center(inputs)
	if (locale === "id") return id_enterprise_command_center(inputs)
	if (locale === "it") return it_enterprise_command_center(inputs)
	if (locale === "ru") return ru_enterprise_command_center(inputs)
	if (locale === "pt") return pt_enterprise_command_center(inputs)
	return ko_enterprise_command_center(inputs)
});